const MODULE_NAME = 'WorkInstructionModule';

export const ADD_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/ADD_WORK_INSTRUCTION_PACKAGE`;
export const DELETE_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/DELETE_WORK_INSTRUCTION_PACKAGE`;
export const FETCH_WORK_INSTRUCTION_PACKAGES = `${MODULE_NAME}/FETCH_WORK_INSTRUCTION_PACKAGES`;
export const ADD_WORK_INSTRUCTION = `${MODULE_NAME}/ADD_WORK_INSTRUCTION`;
export const UPDATE_WORK_INSTRUCTION = `${MODULE_NAME}/UPDATE_WORK_INSTRUCTION`;
export const DELETE_WORK_INSTRUCTION = `${MODULE_NAME}/DELETE_WORK_INSTRUCTION`;
export const ADD_WORK_INSTRUCTION_STEP = `${MODULE_NAME}/ADD_WORK_INSTRUCTION_STEP`;
export const UPDATE_WORK_INSTRUCTION_STEP = `${MODULE_NAME}/UPDATE_WORK_INSTRUCTION_STEP`;
export const DELETE_WORK_INSTRUCTION_STEP = `${MODULE_NAME}/DELETE_WORK_INSTRUCTION_STEP`;
export const FETCH_WORK_INSTRUCTIONS_FOR_PACKAGE = `${MODULE_NAME}/FETCH_WORK_INSTRUCTIONS_FOR_PACKAGE`;
export const LINK_FILES_TO_WORK_INSTRUCTION_STEP = `${MODULE_NAME}/LINK_FILES_TO_WORK_INSTRUCTION_STEP`;
export const LINK_TASKS_TO_WORK_INSTRUCTION_STEP = `${MODULE_NAME}/LINK_TASKS_TO_WORK_INSTRUCTION_STEP`;
export const SIGN_OFF_STEP = `${MODULE_NAME}/SIGN_OFF_STEP`;
export const CHANGE_WORK_INSTRUCTION_STEPS_ORDER = `${MODULE_NAME}/CHANGE_WORK_INSTRUCTION_STEPS_ORDER`;
export const CHANGE_WORK_INSTRUCTIONS_ORDER = `${MODULE_NAME}/CHANGE_WORK_INSTRUCTIONS_ORDER`;
export const LINK_FILES_TO_WORK_INSTRUCTION = `${MODULE_NAME}/LINK_FILES_TO_WORK_INSTRUCTION`;
export const LINK_TASKS_TO_WORK_INSTRUCTION = `${MODULE_NAME}/LINK_TASKS_TO_WORK_INSTRUCTION`;
export const FETCH_JOB_WORK_INSTRUCTION_STATUS = `${MODULE_NAME}/FETCH_JOB_WORK_INSTRUCTION_STATUS`;
